"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recordingSettings = exports.getDefaultEndpointEnvSettings = exports.extractRecordingSettings = exports["default"] = void 0;
var recordingSettings = exports.recordingSettings = {
  videoResolution: [
  // { id: '640x360', name: '640x360 (SD)' },
  // { id: '720x480', name: '720x480 (SD)' },
  {
    id: '1280x720',
    name: '1280x720 (HD)'
  }, {
    id: '1920x1080',
    name: '1920x1080 (FHD)'
  }
  // { id: '2560x1440', name: '2560x1440 (QHD)' },
  // { id: '3840x2160', name: '3840x2160 (4K)' },
  ],
  videoFrameRate: [
  // { id: '10', name: '10' },
  // { id: '20', name: '20' },
  {
    id: '24',
    name: '24'
  }, {
    id: '25',
    name: '25 (PAL)'
  }, {
    id: '29.97',
    name: '29.97 (NTSC)'
  }, {
    id: '30',
    name: '30'
  }
  // { id: '48', name: '48' },
  // { id: '50', name: '50 (PAL)' },
  // { id: '59.94', name: '59.94' },
  // { id: '60', name: '60' },
  ],
  videoBitRate: [{
    id: '.5',
    name: '.5 Mbps'
  }, {
    id: '1',
    name: '1 Mbps'
  }, {
    id: '2',
    name: '2 Mbps'
  }, {
    id: '3',
    name: '3 Mbps'
  }, {
    id: '4',
    name: '4 Mbps'
  }, {
    id: '5',
    name: '5 Mbps'
  }
  // { id: '6', name: '6 Mbps' },
  // { id: '7', name: '7 Mbps' },
  // { id: '8', name: '8 Mbps' },
  // { id: '9', name: '9 Mbps' },
  // { id: '10', name: '10 Mbps' },
  ],
  audioBitRate: [{
    id: '32',
    name: '32 kbps (Very low)'
  }, {
    id: '128',
    name: '128 kbps (Low)'
  }, {
    id: '160',
    name: '160 kbps (Medium)'
  }
  // { id: '256', name: '256 kbps (High)' },
  ],
  audioSampleRate: [{
    id: '48',
    name: '48 kHz'
  }],
  videoBufferSize: [{
    id: '500k',
    name: '0.5 Mbps'
  }, {
    id: '1000k',
    name: '1.0 Mbps'
  }, {
    id: '1500k',
    name: '1.5 Mbps'
  }
  // { id: '2000k', name: '2.0 Mbps' },
  ],
  audioDelay: [{
    id: '0',
    name: '0ms'
  }, {
    id: '50',
    name: '50ms'
  }, {
    id: '100',
    name: '100ms'
  }, {
    id: '200',
    name: '200ms'
  }, {
    id: '300',
    name: '300ms'
  }, {
    id: '400',
    name: '400ms'
  }, {
    id: '500',
    name: '500ms'
  }, {
    id: '1000',
    name: '1000ms (1 sec)'
  }, {
    id: '1250',
    name: '1250ms'
  }, {
    id: '1500',
    name: '1500ms'
  }, {
    id: '2000',
    name: '2000ms'
  }]
};
var getDefaultEndpointEnvSettings = exports.getDefaultEndpointEnvSettings = function getDefaultEndpointEnvSettings() {
  return {
    VIDEO_RESOLUTION: recordingSettings.videoResolution[1].id,
    // 1920x1080
    VIDEO_FRAMERATE: recordingSettings.videoFrameRate[3].id,
    // 30
    VIDEO_BITRATE: recordingSettings.videoBitRate[3].id,
    // 3
    AUDIO_BITRATE: recordingSettings.audioBitRate[2].id,
    // 160
    AUDIO_SAMPLE_RATE: recordingSettings.audioSampleRate[0].id,
    // 48
    VIDEO_BUFSIZE: recordingSettings.videoBufferSize[2].id,
    // 1500k
    AUDIO_DELAY: recordingSettings.audioDelay[0].id // 0ms
  };
};
var extractRecordingSettings = exports.extractRecordingSettings = function extractRecordingSettings(env) {
  return {
    VIDEO_RESOLUTION: "".concat(env.SCREEN_WIDTH, "x").concat(env.SCREEN_HEIGHT),
    // 1920x1080
    VIDEO_FRAMERATE: env.VIDEO_FRAMERATE,
    // 30
    VIDEO_BITRATE: parseFloat(env.VIDEO_BITRATE) / 1000,
    // 3
    AUDIO_BITRATE: parseFloat(env.AUDIO_BITRATE),
    AUDIO_SAMPLE_RATE: parseFloat(env.AUDIO_SAMPLERATE) / 1000,
    // 48
    VIDEO_BUFSIZE: env.VIDEO_BUFSIZE,
    // 1500k
    AUDIO_DELAY: env.AUDIO_DELAY // 0
  };
};
var _default = exports["default"] = recordingSettings;